import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getApiRoute = () => 
{
    if (process.env.VUE_APP_ENVIRONMENT === 'local') 
    {
      return 'http://0.0.0.0:8080/api/';
    } 
    else if (process.env.VUE_APP_ENVIRONMENT === 'dev') 
    {
      return 'https://api.mydigitalsolutions.dev/api/';
    } 
    else if (process.env.VUE_APP_ENVIRONMENT === 'prod') 
    {
      return 'https://api.mydigitalsolutions.app/api/';
    } 
    else 
    {
      return 'http://0.0.0.0:8080/api/';
    }
}
  

const VuexInstance = new Vuex.Store({
  state: {

    headers:{
      'Content-Type': 'application/json',
    },

    route_api_rest: getApiRoute(),
    
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
})


export default VuexInstance
